import { WMSAddEditService } from './WMSAddEditService';
import { WMSListServices } from './WMSListServices';
import { useWMSSettings } from '../../WMSLayers/useWMSSettings';
import { useLocalization } from '@ais-ui/locale-management';

export function WMSForm() {
  const { messages } = useLocalization();
  const wmsSettings = useWMSSettings();

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsWmsServicesTitle}
        </h3>
        {wmsSettings.wmsInfos.length > 0 && (
          <WMSAddEditService mode="create"></WMSAddEditService>
        )}
      </div>
      <WMSListServices></WMSListServices>
    </div>
  );
}
